import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Badge from "react-bootstrap/Badge";
import { highlights } from "./highlights-data";
import "./experience.styles.css";

const Experience = () => {
  return (
    <div className="pt-3 pb-3">
      <h1 className="text-center font-details-b pb-2">WORK HIGHLIGHTS</h1>
      <p className="text-center highlights-subtitle pb-3">
        Production systems I've designed and shipped over 3+ years
      </p>
      <Row>
        {highlights.map((item) => (
          <Col xs={12} lg={item.featured ? 12 : 6} className="mb-4" key={item.title}>
            <Card className={`highlight-card h-100${item.featured ? " highlight-featured" : ""}`}>
              <Card.Body className="d-flex flex-column">
                {item.ownership ? (
                  <div className="mb-2">
                    <span className="ownership-badge">★ {item.ownership}</span>
                  </div>
                ) : null}
                <Card.Title className="highlight-title">{item.title}</Card.Title>
                <div className="highlight-domain mb-3">{item.domain}</div>

                <div className="mb-3">
                  {item.impact.map((metric) => (
                    <Badge key={metric} className="impact-badge mr-2 mb-2">
                      {metric}
                    </Badge>
                  ))}
                </div>

                <strong>What I built</strong>
                <ul className="highlight-list pt-1">
                  {item.built.map((point) => (
                    <li key={point}>{point}</li>
                  ))}
                </ul>

                <div className="mt-auto pt-2">
                  {item.tech.map((t) => (
                    <span key={t} className="tech-chip">
                      {t}
                    </span>
                  ))}
                  {item.liveUrl ? (
                    <a
                      className="highlight-live"
                      href={item.liveUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View live ↗
                    </a>
                  ) : null}
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default Experience;
